import React, { useEffect } from "react";

import { requiresAuth } from "pages/UserAuth/requiresAuthHOC";
import { useSelector } from "react-redux";
import {
  isAdminUser,
  isLicenseExpired,
  isTrialLicense,
} from "ee/selectors/organizationSelectors";

import LicenseCheckPageNonAdmin from "./Components/LicenseCheckPageNonAdmin";
import LicenseCheckPageFreshInstance from "./Components/LicenseCheckPageFreshInstance";
import LicenseCheckPageExpiredTrial from "./Components/LicenseCheckPageExpiredTrial";
import LicenseCheckPageExpiredPaid from "./Components/LicenseCheckPageExpiredPaid";
import AILicenceExpiredPage from "./Components/AILicenceExpiredPage";
import ChoosePlan from "../CloudBillingWelcome/ChoosePlan";
import { useIsCloudBillingEnabled } from "hooks";
import { getIsAiAgentInstanceEnabled } from "ee/selectors/aiAgentSelectors";
import { isPylonChatAvailable } from "utils/bootPylon";

function LicenseCheckPage() {
  const isAdmin = useSelector(isAdminUser);
  const isExpired = useSelector(isLicenseExpired);
  const isTrial = useSelector(isTrialLicense);

  const isCloudBillingEnabled = useIsCloudBillingEnabled();
  const isAiAgentInstanceEnabled = useSelector(getIsAiAgentInstanceEnabled);

  useEffect(function showPylonOnLicensePage() {
    if (isPylonChatAvailable()) {
      window.Pylon("show");
    }

    return () => {
      if (isPylonChatAvailable()) {
        window.Pylon("hide");
      }
    };
  }, []);

  if (!isAdmin) {
    return <LicenseCheckPageNonAdmin />;
  } else {
    if (isExpired) {
      if (isAiAgentInstanceEnabled) {
        return <AILicenceExpiredPage />;
      } else if (isTrial) {
        return <LicenseCheckPageExpiredTrial />;
      } else {
        return <LicenseCheckPageExpiredPaid />;
      }
    }

    return isCloudBillingEnabled ? (
      <ChoosePlan />
    ) : (
      <LicenseCheckPageFreshInstance />
    );
  }
}

export default requiresAuth(LicenseCheckPage);
